export const staffDirectoryQuery = `
  query staff($section: [String], $id: [QueryArgument], $limit: Int, $offset: Int, $orderBy: String, $search: String, $relatedTo: [QueryArgument]) {
    entries(section: $section, id: $id, limit: $limit, offset: $offset, orderBy: $orderBy, search: $search, relatedTo: $relatedTo) {
      ... on staff_Entry {
        id
        title
        firstName
        lastName
        url
        jobTitle
        emailAddress
        phoneNumber
        schoolBuilding {
          title
        }
        customLinks {
          ... on linkBlock_Entry {
            linkField {
              ariaLabel
              customText
              target
              text
              title
              type
              url
            }
          }
        }
        headshot {
          url
          ... on media_Asset {
            altText
          }
        }
      }
      ... on staffHasSignature_Entry {
        id
        title
        firstName
        lastName
        url
        jobTitle
        emailAddress
        phoneNumber
        schoolBuilding {
          title
        }
        customLinks {
          ... on linkBlock_Entry {
            linkField {
              ariaLabel
              customText
              target
              text
              title
              type
              url
            }
          }
        }
        headshot {
          url
          ... on media_Asset {
            altText
          }
        }
      }
    }
    entryCount(section: $section, id: $id, limit: $limit, offset: $offset, orderBy: $orderBy, search: $search, relatedTo: $relatedTo)
  }
`

export const staffCategoriesQuery = `{
  categoriesConnection {
    totalCount
    edges {
      node {
        id
        title
        level
        parent {
          id
        }
        group {
          id
          handle
        }
      }
      relatedEntries(section:staff) {
        totalCount
      }
    }
  }
}`

export const staffDirectoryCategoriesQuery = `
  query EventsCategoriesQuery($siteId: [QueryArgument]) {
    categories:entries(section: "schoolProgramFilters", siteId: $siteId, showInStaffDirectory: true) {
      id
      title
      level
      parent {
        id
      }
      groupId:sectionId
      groupHandle:sectionHandle
    }
  }

`
